<template>
  <div class="dialog-overlay" v-if="isVisible" @click.self="handleOverlayClick">
    <div class="dialog-container">
      <!-- Alert Icon -->
      <div class="icon-container">
        <!-- <svg
          class="alert-icon"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12 9V13M12 17H12.01M10.29 3.86L1.82 18C1.64537 18.3024 1.55299 18.6453 1.55201 18.9945C1.55103 19.3437 1.64149 19.6871 1.81442 19.9905C1.98735 20.2939 2.23672 20.5467 2.53771 20.7239C2.83869 20.901 3.18082 20.9962 3.53 21H20.47C20.8192 20.9962 21.1613 20.901 21.4623 20.7239C21.7633 20.5467 22.0127 20.2939 22.1856 19.9905C22.3585 19.6871 22.449 19.3437 22.448 18.9945C22.447 18.6453 22.3546 18.3024 22.18 18L13.71 3.86C13.5317 3.56611 13.2807 3.32312 12.9812 3.15448C12.6817 2.98585 12.3437 2.89725 12 2.89725C11.6563 2.89725 11.3183 2.98585 11.0188 3.15448C10.7193 3.32312 10.4683 3.56611 10.29 3.86Z"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg> -->
      </div>

      <!-- Header -->
      <div class="dialog-header">
        <h2 class="dialog-title">Add Your Company!</h2>
        <!-- <button
          class="close-btn"
          @click="closeDialog"
          aria-label="Close dialog"
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M15 5L5 15M5 5L15 15"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button> -->
      </div>

      <!-- Content -->
      <div class="dialog-content">
        <div class="expiry-badge">
          <svg
            class="clock-icon"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10 5V10L13 13M19 10C19 14.9706 14.9706 19 10 19C5.02944 19 1 14.9706 1 10C1 5.02944 5.02944 1 10 1C14.9706 1 19 5.02944 19 10Z"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <span class="expiry-text"
            ><strong
              >If Your Company is Already Using {{ getAppName }}, Consult Your
              Company Admin To Add You</strong
            ></span
          >
        </div>

        <!-- <p class="main-message">
          <strong></strong>

          <br />
        </p> -->

        <div class="warning-box">
          <svg
            class="warning-icon"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10 7V11M10 14H10.01M19 10C19 14.9706 14.9706 19 10 19C5.02944 19 1 14.9706 1 10C1 5.02944 5.02944 1 10 1C14.9706 1 19 5.02944 19 10Z"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <strong> </strong><br />
          <span style="color: white"
            >⏳ If Your Company is NOT Already Using {{getAppName}}, Click
            Below To Add Your Company</span
          >
        </div>
      </div>

      <!-- Actions -->
      <div class="dialog-actions">
        <button class="primary-btn" @click="addNewCompany">
          <svg
            class="btn-icon"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M3 10H17M17 10L13 6M17 10L13 14"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          Click Here To Add Your Business
        </button>
        <button class="secondary-btn" @click="handleRemindLater">
          Remind Me Later
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: { dialog: { default: false } },
  watch: {
    dialog(newVal) {
      this.isVisible = newVal;
    },
  },
  computed:{
    getAppName(){
      return this.$store.getters.getAppName
    }
  },
  mounted() {
    this.isVisible = this.dialog;
  },
  data() {
    return {
      isVisible: false,
    };
  },
  methods: {
    closeDialog() {
      this.isVisible = false;
      this.$emit("close-dialog");
    },
    handleOverlayClick() {
      // Optionally close on overlay click
      // this.closeDialog();
    },
    addNewCompany() {
      this.$emit("add-company");
      this.closeDialog();
    },
    handleRemindLater() {
      this.$emit("remind-later");
      this.closeDialog();
    },
  },
};
</script>

<style scoped>
.dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  animation: fadeIn 0.2s ease-in-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.dialog-container {
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  width: 90%;
  max-width: 560px;
  position: relative;
  animation: slideUp 0.3s ease-out;
}

@keyframes slideUp {
  from {
    transform: translateY(20px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.icon-container {
  display: flex;
  justify-content: center;
  padding: 32px 32px 0;
}

.alert-icon {
  width: 64px;
  height: 64px;
  color: #f59e0b;
  animation: pulse 2s ease-in-out infinite;
}

@keyframes pulse {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.7;
  }
}

.dialog-header {
  padding: 16px 32px 0;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.dialog-title {
  font-size: 28px;
  font-weight: 700;
  color: #014241;
  margin: 0;
  letter-spacing: -0.02em;
}

.close-btn {
  background: none;
  border: none;
  color: #9ca3af;
  cursor: pointer;
  padding: 4px;
  border-radius: 6px;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
}

.close-btn:hover {
  background-color: #f3f4f6;
  color: #6b7280;
}

.dialog-content {
  padding: 24px 32px;
}

.expiry-badge {
  display: flex;
  align-items: center;
  gap: 10px;
  background: linear-gradient(135deg, #c7fef9 0%, #a9fd8a 100%);
  border: 2px solid #f59e0b;
  border-radius: 10px;
  padding: 14px 18px;
  margin-bottom: 20px;
}

.clock-icon {
  width: 20px;
  height: 20px;
  color: #d97706;
  flex-shrink: 0;
}

.expiry-text {
  font-size: 14px;
  color: #0f1178;
  line-height: 1.4;
}

.expiry-text strong {
  font-weight: 700;
  color: #0e1992;
}

.main-message {
  font-size: 16px;
  line-height: 1.6;
  color: #374151;
  margin: 0 0 20px 0;
}

.main-message strong {
  font-weight: 700;
  color: #1f2937;
}

.warning-box {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  background-color: #3e6836;
  border-left: 4px solid #dc2626;
  border-radius: 8px;
  padding: 16px;
}

.warning-icon {
  width: 20px;
  height: 20px;
  color: #dc2626;
  flex-shrink: 0;
  margin-top: 2px;
}

.warning-box span {
  font-size: 15px;
  color: #991b1b;
  line-height: 1.5;
  font-weight: 500;
}

.dialog-actions {
  padding: 0 32px 32px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.primary-btn {
  background: linear-gradient(135deg, #052d47 0%, #052560 100%);
  color: #ffffff;
  border: none;
  border-radius: 10px;
  padding: 16px 24px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  box-shadow: 0 4px 12px rgba(220, 38, 38, 0.3);
}

.primary-btn:hover {
  background: linear-gradient(135deg, #084c08 0%, #033428 100%);
  box-shadow: 0 6px 16px rgba(220, 38, 38, 0.4);
  transform: translateY(-1px);
}

.primary-btn:active {
  transform: translateY(0);
}

.btn-icon {
  width: 20px;
  height: 20px;
}

.secondary-btn {
  background: transparent;
  color: #6b7280;
  border: 2px solid #e5e7eb;
  border-radius: 10px;
  padding: 14px 24px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.secondary-btn:hover {
  background-color: #f9fafb;
  border-color: #d1d5db;
  color: #4b5563;
}

@media (max-width: 640px) {
  .dialog-container {
    width: 95%;
    margin: 16px;
  }

  .icon-container {
    padding: 24px 24px 0;
  }

  .alert-icon {
    width: 48px;
    height: 48px;
  }

  .dialog-header {
    padding: 12px 24px 0;
  }

  .dialog-title {
    font-size: 24px;
  }

  .dialog-content {
    padding: 20px 24px;
  }

  .dialog-actions {
    padding: 0 24px 24px;
  }

  .primary-btn {
    font-size: 15px;
    padding: 14px 20px;
  }
}
</style>
